import { FC, useEffect } from 'react';
import { CssBaseline, GlobalStyles } from '@mui/material';
import { Box } from '@wellstone-solutions/web';
import { Outlet } from 'react-router-dom';

import { Footer } from '@components/Footer';
import { ROOT_TITLE } from '@constants/page';
import { useCurrentRoute } from '@hooks/useCurrentRoute';

const RootLayout: FC = () => {
  const { route } = useCurrentRoute();

  useEffect(() => {
    document.title = route?.pageMeta?.title ?? ROOT_TITLE;
  }, [route]);

  return (
    <>
      <CssBaseline />
      <GlobalStyles
        styles={(theme) => ({
          body: {
            background: theme.palette.background.default,
            backgroundAttachment: 'fixed',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            margin: 0,
            padding: 0,
          },
        })}
      />
      <Box component="section" sx={styles.header} />
      <Box component="main" sx={styles.main}>
        <Outlet />
      </Box>
      <Footer />
    </>
  );
};

const styles = {
  header: {
    paddingTop: '80px',
  },
  main: {
    flexGrow: 1,
    padding: '0 18px 24px 18px',
  },
};

export { RootLayout };
